import React from "react";
import { HelpCircle } from "lucide-react";
import { FormCard } from "@/components/FormCard";
import { Checkbox, Tooltip } from "@/components/ui";
import { PreviewDeviceTabs, PreviewPlayerField, UrlField } from "../../components/PreviewControlFields";
import { PreviewPlayerState } from "../../components/usePreviewPlayer";

interface Props {
  preview: PreviewPlayerState;
  includeAutoResize: boolean;
  onIncludeAutoResizeChange: (includeAutoResize: boolean) => void;
  embedUrl: string;
  isSamplePreview: boolean;
}

const ReviewWidgetPreviewControls: React.FC<Props> = ({
  preview,
  includeAutoResize,
  onIncludeAutoResizeChange,
  embedUrl,
  isSamplePreview,
}) => (
  <FormCard>
    <FormCard.Header title="Preview Controls" description="These options only update the preview and snippet." />

    <FormCard.Content>
      <PreviewDeviceTabs value={preview.previewDevice} onChange={preview.setPreviewDevice} />

      <div className="flex items-center gap-1.5">
        <Checkbox
          id="include-auto-resize"
          label="Auto-resize"
          checked={includeAutoResize}
          onCheckedChange={checked => onIncludeAutoResizeChange(!!checked)}
        />
        <Tooltip>
          <Tooltip.Trigger
            render={
              <button
                type="button"
                className="inline-flex items-center text-slate-400 hover:text-slate-600 transition-colors focus:outline-none"
                aria-label="About auto-resize"
              >
                <HelpCircle className="size-3.5" />
              </button>
            }
          />
          <Tooltip.Content className="max-w-64">
            When enabled, the snippet listens for height updates from the embed and resizes the iframe to fit. Turn it
            off to keep a fixed height with scrollable content.
          </Tooltip.Content>
        </Tooltip>
      </div>

      <PreviewPlayerField players={preview.players} />

      <UrlField label="Embed URL" url={embedUrl} canOpen={!isSamplePreview} />
    </FormCard.Content>
  </FormCard>
);

export { ReviewWidgetPreviewControls };
